export default "__VITE_ASSET__d48cdc60__"